import { HeaderType, HeaderObject } from 'elc-universal-utils';

export const AUTHORIZATION_HEADER_NAME = 'AuthorizationToken';
export const BUSINESS_UNIT_HEADER_NAME = 'Business-Unit';

export interface IError {
    status: number;
}
export interface IDataMapperOperations {
    [key: string]: Function | undefined;
    request?(request: {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        [k: string]: any;
    }): {};
    response?(response: {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        [k: string]: any;
    }): {};
}
export interface IDataMappings {
    [key: string]: IDataMapperOperations;
}
export interface IResponse<T> {
    data: T;
    reponseHeaders: Headers;
}
export interface IPayload {
    url: string;
    body?: {};
    options?: {};
    headers?: {};
    returnAsPlainText?: boolean;
}
export interface IGetPayload {
    url: string;
    options?: {};
    headers?: {};
    params?: {};
}
export interface IRequestOptions {
    debounceInterval?: number;
    bypassCache?: boolean;
}
export interface IHttpTransport {
    addGlobalHeaders(header: HeaderObject): void;
    removeGlobalHeader(headerName: string): void;
    delete<T>(payload: string | IPayload): Promise<IResponse<T>>;
    post<T>(payload: IPayload): Promise<IResponse<T>>;
    patch<T>(payload: IPayload): Promise<IResponse<T>>;
    put<T>(payload: IPayload): Promise<IResponse<T>>;
    get<T>(payload: string | IGetPayload, IRequestOptions?: IRequestOptions): Promise<IResponse<T>>;
}
export interface IDataMapper {
    // eslint-disable-next-line @typescript-eslint/ban-types
    mapRequest(name: string, request: Object): {};
    // eslint-disable-next-line @typescript-eslint/ban-types
    mapResponse(name: string, response: Object): {};
    dataMappings?: IDataMappings;
}

export interface IConfig {
    cartId?: string;
    httpTransport: IHttpTransport;
    dataMapper?: IDataMapper;
    businessUnitId?: string;
    drupalDomain?: string;
}

export class Api {
    protected bearerToken: string;
    protected httpTransport: IHttpTransport;
    protected businessUnitId: string | undefined;

    constructor(configStore: IConfig) {
        this.httpTransport = configStore.httpTransport;
        this.businessUnitId = configStore.businessUnitId;
    }

    public addHeader(header: HeaderObject) {
        this.httpTransport.addGlobalHeaders(header);
    }

    public removeHeader(headerName: HeaderType) {
        this.httpTransport.removeGlobalHeader(headerName);
    }

    public setBearerToken(bearerToken: string) {
        if (bearerToken) {
            this.addHeader({
                [AUTHORIZATION_HEADER_NAME]: `${bearerToken}`
            });
        } else {
            this.removeHeader(AUTHORIZATION_HEADER_NAME);
        }
    }
}
